__webpack_require__.p = "/my-simple-app/";